import * as React       from 'react';
import {
    useNavigate,
    useLocation
}                       from 'react-router-dom';
import Box              from '@mui/material/Box';
import Card             from '@mui/material/Card';
import Container        from "@mui/material/Container";
import IconButton       from '@mui/material/IconButton';
import useMediaQuery    from '@mui/material/useMediaQuery';
import useTheme         from '@mui/material/styles/useTheme';
import ArrowBack        from '@mui/icons-material/ArrowBack';
import Copyright        from "ui/components/Copyright";
import TopBar           from "ui/components/dashboard-components/TopBar";
import Toolbar from '@mui/material/Toolbar';

export default function FormLayout(
    props: {
        children: React.ReactNode,
        showBackButton?: boolean,
        showTopBar?: boolean,
        white?: boolean,
        hideProfileMenu?: boolean,
    }
): JSX.Element {
    const navigate = useNavigate();
    const location = useLocation();
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.up('sm'));
    const showTopBar = props.showTopBar === undefined ? true : props.showTopBar;
    let showBackButton = props.showBackButton === undefined ? false : props.showBackButton;
    if (props.showBackButton === undefined && (location.state as {back: string})?.back) {
        showBackButton = true;
    };
    let mt = 10;
    let pb = 4;
    if (matches) {
        mt = 9;
        pb = 8;
    }
    if (props.white) {
        mt = 0;
        pb = 0;
    }
    const back = (location.state as {back?: string})?.back;
    return (
        <Box sx={props.white ? {backgroundColor: 'background.paper'} : {}}>
            {showTopBar &&
                <>
                    <TopBar
                        open={false}
                        toggleDrawer={()=><></>}
                        bgcolorLight={props.white ? "background.paper" :"background.default"}
                        bgcolorDark="background.paper"
                        hideProfileMenu={props.hideProfileMenu}
                    />
                    <Toolbar/>
                </>
            }
            <Container component="main" maxWidth="sm">
                <Box
                    sx={{
                        marginTop: mt,
                        display: 'flex',
                        flexDirection: 'column',
                        backgroundColor: 'background.paper',
                        backgroundImage: 'linear-gradient(rgba(255, 255, 255, 0.05), rgba(255, 255, 255, 0.05))',
                        borderRadius: 1,
                        // Layout guide: title sits 88px from the top either way —
                        // 32 (top) + 24 (icon) + 32 (gap) when a back arrow shows, else 88 directly.
                        pt: showBackButton ? 4 : 11,
                        pb: pb,
                        px: matches ? 8 : 3,
                    }}
                >
                    {showBackButton &&
                        <IconButton
                            onClick={() => (back ? navigate(back) : navigate(-1))}
                            color='secondary'
                            aria-label="Back"
                            sx={{ p: 0, mb: 4, alignSelf: 'flex-start' }}
                        >
                            <ArrowBack sx={{ fontSize: 24 }}/>
                        </IconButton>
                    }
                    <Card
                        sx={{
                            boxShadow: 'none',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            borderRadius: 1,
                            gap: 3,
                            p: 0,
                            width: '100%',
                        }}
                    >
                        {props.children}
                    </Card>
                </Box>
            </Container>
            <Copyright sx={{ mt: 10, pb: 10 }} />
        </Box>
    );
}